import { useEffect, useState } from 'react';
import { DefaultEditor } from '@drodil/backstage-plugin-toolbox';
import { convert, ConversionDirection } from './iamPolicyConverter';

const MODE_TO_TERRAFORM = 'IAM → Terraform';
const MODE_TO_POLICY = 'Terraform → IAM';
const modes = [MODE_TO_TERRAFORM, MODE_TO_POLICY];

const samplePolicy = JSON.stringify(
  {
    Version: '2012-10-17',
    Statement: [
      {
        Sid: 'S3StateObjects',
        Effect: 'Allow',
        Action: ['s3:PutObject', 's3:GetObject', 's3:DeleteObject'],
        Resource: 'arn:aws:s3:::*/*',
      },
      {
        Sid: 'Ec2CreateTagsManagedByPlatform',
        Effect: 'Allow',
        Action: 'ec2:CreateTags',
        Resource: [
          'arn:aws:ec2:*:*:security-group/*',
          'arn:aws:ec2:*:*:security-group-rule/*',
        ],
        Condition: {
          StringEquals: {
            'aws:RequestTag/managed_by': 'platform-deploy-aws',
          },
        },
      },
    ],
  },
  null,
  2,
);

export const IamPolicyToolboxTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [mode, setMode] = useState<string>(MODE_TO_TERRAFORM);

  useEffect(() => {
    if (!input.trim()) {
      setOutput('');
      return;
    }
    const direction: ConversionDirection =
      mode === MODE_TO_POLICY ? 'terraformToPolicy' : 'policyToTerraform';
    try {
      setOutput(convert(input, direction));
    } catch (e) {
      setOutput(e instanceof Error ? e.message : String(e));
    }
  }, [input, mode]);

  return (
    <DefaultEditor
      input={input}
      setInput={setInput}
      output={output}
      mode={mode}
      setMode={setMode}
      modes={modes}
      sample={samplePolicy}
      inputLabel={mode === MODE_TO_POLICY ? 'Terraform statements' : 'IAM policy'}
      outputLabel={mode === MODE_TO_POLICY ? 'IAM policy' : 'Terraform statements'}
      allowFileUpload
      acceptFileTypes=".json"
      allowFileDownload
      downloadFileName={
        mode === MODE_TO_POLICY ? 'policy.json' : 'statements.json'
      }
      downloadFileType="application/json"
    />
  );
};

export default IamPolicyToolboxTool;
